import React from 'react';
import PropTypes from 'prop-types';

import { isNotNilOrEmpty } from 'lib/Helpers';
import { addCommasToNumber, convertNumberToShortHand } from 'lib/Formatting';

/**
 * @function AbbreviatedNumberCellRenderer
 * @param {Object} props
 * @return {ReactElement}
 */
const AbbreviatedNumberCellRenderer = ({ cellData }) => isNotNilOrEmpty(cellData)
  ? (
    <div title={addCommasToNumber(cellData)}>
      {convertNumberToShortHand(cellData, 2)}
    </div>
  )
  : '-';

AbbreviatedNumberCellRenderer.propTypes = {
  cellData: PropTypes.number,
};

export default AbbreviatedNumberCellRenderer;
